"use strict";
exports.__esModule = true;
var banners = {
    test_banner: {
        pct: 'a',
        pfc: 'a',
        pfb: 'a',
        plp: 'a',
        pli: 'a',
        pop: 'a',
        pt: 'b',
        p1: 'bvpsn',
        p2: 'fkup'
    },
    tgb_in_offers_list: {
        pct: 'b',
        pfc: 'a',
        pfb: 'a',
        plp: 'a',
        pli: 'a',
        pop: 'a',
        pt: 'b',
        pd: '9',
        pw: '5',
        pv: '18',
        p1: 'bvkiw',
        p2: 'fkgw',
        random: '766531297'
    },
    tgb_in_card: {
        pfc: 'a',
        pfb: 'a',
        plp: 'a',
        pli: 'a',
        pop: 'a',
        pt: 'b',
        p1: 'bwbdj',
        p2: 'fmbw'
    },
    credit_or_mortgage: {
        pfc: 'a',
        pfb: 'a',
        plp: 'a',
        pli: 'a',
        pop: 'a',
        pt: 'b',
        p1: 'bwbqj',
        p2: 'fmcm'
    },
    parallax_in_offers_list: {
        pct: 'b',
        pfc: 'a',
        pfb: 'a',
        plp: 'a',
        pli: 'a',
        pop: 'a',
        pt: 'b',
        p1: 'buvpc',
        p2: 'ffmc'
    },
    parallax_in_offers_list_map: {
        p1: 'bzyjd',
        p2: 'fvyi'
    },
    apps: {
        pct: 'a',
        pfc: 'a',
        pfb: 'a',
        plp: 'a',
        pli: 'a',
        pop: 'a',
        pt: 'b',
        p1: 'bvord',
        p2: 'fksk'
    },
    new_buildings: {
        pct: 'a',
        pfc: 'a',
        pfb: 'a',
        plp: 'a',
        pli: 'a',
        pop: 'a',
        pt: 'b',
        p1: 'bvsji',
        p2: 'fksj'
    },
    mortgage_offer_card_banner: {
        p1: 'byelt',
        p2: 'fkib'
    }
};
function getBannerByType(type) {
    return banners[type];
}
exports.getBannerByType = getBannerByType;
//# sourceMappingURL=banners.js.map